import React from 'react';
import ReportingMembershipsRevenuePage from '../components/ReportingMembershipsRevenuePage';

const ReportingMembershipsRevenueApp = (props) => (
  <ReportingMembershipsRevenuePage {...props} />
);

export default ReportingMembershipsRevenueApp;
